let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1pBzI")).then(() => parcelRequire('cqUbR'));